import React from "react";
import { demoConfig } from "../consfig";

const DemoScreen = ({ target }) => {
  const config = demoConfig[target];

  if (!config) {
    return (
      <div className="w-full min-h-screen flex items-center justify-center">
        <h2 className="text-xl font-semibold text-gray-600">404 Not Found</h2>
      </div>
    );
  }

  return (
    <div className="w-full min-h-screen flex flex-col items-center justify-start mt-32 px-4">
      <h1 className="text-2xl md:text-3xl font-normal text-primary text-center mb-5">
        {config.title}
      </h1>

      <div className="w-full max-w-4xl aspect-video shadow-lg rounded-lg overflow-hidden">
        <video controls className="w-full h-full">
          <source src={config.videoUrl} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    </div>
  );
};

export default DemoScreen;
